import {
  CreateGridBulkRequest,
  CreateGridResponse,
} from '../../types/plans/types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';

export const createGrid = async (
  body: CreateGridBulkRequest
): Promise<{
  data: CreateGridResponse;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }

  const url = `/resourceMatrix/insurance/create_grid?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as unknown as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    loading = false;
    return { data: responseData as CreateGridResponse, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to create provider credential');
  }
};
